export class AcquireCampaignBuilder {
    constructor() {
        this.campaign = {};
    }

    setId(id){
        this.campaign.id = id;
        return this;
    }

    setName(name){
        this.campaign.name = name;
        return this;
    }

    setComments(comments){
        this.campaign.comments = comments;
        return this;
    }

    setEngagementRate(engagementRate) {
        this.campaign.engagementRate = engagementRate;
        return this;
    }


    setEngagements(engagements) {
        this.campaign.engagements = engagements;
        return this;
    }

    setLikes(likes) {
        this.campaign.likes = likes;
        return this;
    }

    setReplies(replies){
        this.campaign.replies = replies;
        return this;
    }

    setFollows(follows) {
        this.campaign.follows = follows;
        return this;
    }

    setFollowsRate(followsRate) {
        this.campaign.followsRate = followsRate
        return this;
    }

    setActions(actions){
        this.campaign.actions = actions;
        return this;
    }

    setParam(param){
        this.campaign.param = param;
        return this;
    }

    build(){
        return this.campaign;
    }
}
